var map = {
	"./amos.jpg": 321,
	"./david-seisun.jpg": 7355,
	"./jeremy-mifsud.jpg": 2650,
	"./jonathan-mifsud.jpg": 7001,
	"./rose-bonnici.jpg": 53
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9470;